import { CSSProperties, FC } from "react";
import { Table } from "antd";
import { clsx } from "clsx";
import { QualityCostTradeOff } from "../../../../types/IntelligenceTypes";
import styles from "./MarketTrendsCommon.module.less";

const { Column } = Table;

interface QualityCostTradeOffsProps {
    data?: QualityCostTradeOff[];
    style?: CSSProperties;
}

export const QualityCostTradeOffs: FC<QualityCostTradeOffsProps> = ({ data, style }) => {
    if (!data?.length) return null;

    return (
        <div style={style}>
            <div className={clsx(styles.tableTitle, "sectionTitle")}>
                Quality vs cost trade-offs
            </div>
            <Table dataSource={data} pagination={false} size="small">
                <Column title="Performance Quality" dataIndex="performance" width={334} />
                <Column title="Pricing" dataIndex="pricing" width={334} />
                <Column title="Customer Sentiment" dataIndex="sentiment" width={334} />
                <Column title="Value-for-Money Assessment" dataIndex="assessment" />
            </Table>
        </div>
    );
};
